import { render } from "./NewTypeahead.vue?vue&type=template&id=3b584bfd&ts=true"
import script from "./NewTypeahead?vue&type=script&lang=ts&external"
export * from "./NewTypeahead?vue&type=script&lang=ts&external"

import "./NewTypeahead.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__